var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{attrs:{"type":"daterange","range-separator":"Hasta","start-placeholder":"Fecha Inicial","end-placeholder":"Fecha Final"},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})
}
var staticRenderFns = []

export { render, staticRenderFns }